import React, {useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";
import {Box, Typography} from '@mui/material';
import {getRandomGuardianMessage} from "./GuardianMessages";
import styles from './IncomingMessageBox.module.scss';

export const IncomingMessageBox: React.FC<{ selectedGuardian: any | null }> = ({selectedGuardian}) => {
    const [guardianMessage, setGuardianMessage] = useState("");
    const location = useLocation();
    const currentPath = location.pathname;
    const lastSegment = currentPath.split('/').filter(Boolean).pop();

    useEffect(() => {
        if (selectedGuardian) {
            if (lastSegment === 'choose-guardian') {
                setGuardianMessage(selectedGuardian.message);
            } else {
                const message = getRandomGuardianMessage(
                    selectedGuardian.name,
                    lastSegment ?? ''
                );
                setGuardianMessage(message);
            }
        }
    }, [lastSegment, location, selectedGuardian]);

    return (
        <>
            {/* ================= Guardian Message ================= */}
            <Box
                className={"MuiSideBar guardian-communication-box"}
                height={"50%"}
                maxHeight={"50%"}
            >
                <Box className={"titleBox"}>
                    <Typography variant="subtitle2" className={"titleText common-title-font-size "}>
                        Guardian Message
                    </Typography>
                </Box>

                {selectedGuardian ? (
                    <Box className={`${styles.guardianMessageContainer}`}>
                        <Box
                            component="img"
                            src={selectedGuardian.image}
                            alt={selectedGuardian.name}
                            className={`${styles.guardianAvatar}`}
                        />

                        <Typography
                            variant="body2"
                            className={`messageText ${styles.guardianMessageText}`}
                        >
                            {guardianMessage}
                        </Typography>

                        <Typography
                            variant="body2"
                            className={`messageText ${styles.guardianMessageFooter}`}
                        >
                            If you wish to report any bugs in the system, please email us at
                            SCZ.guardians@gmail.com
                        </Typography>
                    </Box>
                ) : (
                    <Typography variant="body2" className={"messageText"}>
                        Welcome to Scam Protect, please select your guardian!
                    </Typography>
                )}
            </Box>

            {/* ================= System Message ================= */}
            <Box
                className={"MuiSideBar incoming-message-box"}
                height={"calc(50% - 20px)"}
            >
                <Box className={"titleBox"}>
                    <Typography variant="subtitle2" className={"titleText"}>
                        System Message
                    </Typography>
                </Box>

                <Box className={`${styles.systemMessageContainer}`}>
                    <Typography
                        variant="body2"
                        className={`messageText ${styles.guardianMessageText}`}
                    >
                        Welcome to Scam Protect. We offer a suite of services to protect you from scams,
                        including using our novel approach of elemental fingerprinting to identify
                        possible scam scenarios. Click on the "Introduction Tutorial", under
                        "Choose Your Guardian" tab if you need help with using Scam Protect.
                    </Typography>
                </Box>
            </Box>
        </>
    );
};
